import { HANDLE_PRODUCT, RESET } from '../actions';

const initialState = {
	total: 0,
    page: 0,
    perPage: 10,
    search: "",
    product: [],
	productList: [],
	listOption: "Favourites",
	searchOption: "1",
	deviceType: ""
};

export default function productReducer(state = initialState, action) {
	switch (action.type) {
		case HANDLE_PRODUCT:
			return {
				...state,
				...action.data
			};
		case RESET:
			return initialState;
		default:
			return state;
	}
}
